
export default {
  campaignCreatorTitle: "Fusion Campaign Creator",
  campaignDetails: "Campaign Details",
  creativeContent: "Creative Content",
  creativeAssets: "Creative Assets",
  supportedImageFormats: "Supported image formats: JPG, JPEG, PNG, GIF",
  supportedVideoFormats: "Supported video formats: MP4, MPEG, 3GP, AVI, MOV",
  bestDisplayResolution: "Best display resolution: 1080x1920 (Waki: 2225x3562)",
  dragAndDrop: "Drag and drop files here or click to upload",
  multipleFilesSupported: "Multiple files supported",
  remove: "Remove",
  exampleAdvertisements: "Example Advertisements",
  seeHowAds: "See how your ads will be displayed on our devices",
  uploadCreative: "Upload Creative",
  customizeYourCampaign: "Customize Your Campaign",
  campaignCustomizeDescription: "Now give your campaign a name to identify it easily and upload your creative assets for each media owner.",
  campaignName: "Campaign Name",
  enterCampaignName: "Enter your campaign name",
  campaignNameHelp: "To help you to identify your campaign easily",
  dimensions: "Dimensions",
  material: "Material",
  width: "Width",
  height: "Height",
  pleaseUploadCorrectDimensions: "Please upload the correct dimensions for the ad to be displayed correctly",
  others: "Others",
  dropImageOrVideo: "Drop your image or video here, or",
  browse: "browse",
  uploading: "Uploading...",
  uploadDifferentContent: "Upload different content for each location",
  takeYourDesignToNextLevel: "Take Your Design To The Next Level",
  designTipsDescription: "Here are some tips to take your design to the next level so your audience take the maximum value from it",
  locationSpecificContent: "Location-Specific Content",
  mediaOwnerSpecificContent: "Media Owner Content",
  noMediaOwnersAvailable: "No media owners available",
  
  // Upload options
  uploadOptions: "Creative Upload Options",
  sameContentAll: "Use the same content for all locations",
  differentContentLocation: "Use different content for each location",
  differentContentMediaOwner: "Use different content for each media owner",
  
  // Design Tips
  cultureRelevance: "Cultural Relevance",
  cultureRelevanceNote: "Incorporate visuals and messaging that resonate with the local culture of your target locations. Culturally relevant ads tend to perform 30% better than generic content.",
  visualClarity: "Visual Clarity",
  visualClarityNote: "Keep your design clean with high contrast text on appropriate backgrounds. Remember that viewers will only see your ad for a few seconds, so clarity is essential for message retention.",
  callToAction: "Compelling Call-to-Action",
  callToActionNote: "Every effective ad needs a clear call-to-action. Tell your audience exactly what you want them to do next - whether it's visiting your website, calling a number, or visiting your location.",
} as const;
